import { app } from '@/main'
import moment from 'moment'

// mutations
import audienceId from '@/store/mutations/audienceId'
import slideOptions from '@/store/mutations/slideOptions'
import slides from '@/store/mutations/slides'

export default {
  ...audienceId,
  ...slideOptions,
  ...slides,
  setLang: (state, payload) => {
    app.$i18n.locale = payload
    moment.locale(payload)
  },

  // Set presentation
  setSlide: (state, payload) => {
    state.slide.id = null
    state.slide = payload
  },

  // Update Presentation
  updateSlide: (state, payload) => {
    state.slide = { ...state.slide, ...payload }
  },

  // Set presentation
  setPresentation: (state, payload) => {
    state.presentation.id = null
    state.presentation = payload
  },

  // Update Presentation
  patchPresentation: (state, payload) => {
    state.presentation = { ...state.presentation, ...payload }
  },

  setConnectionError: (state, payload) => {
    state.connectionError = payload
  },

}
